import React, { Fragment } from 'react'
import { Button, Card, CardBody, Col, Container, Row } from 'reactstrap';
import { TableStriped } from '../../../components/tables/TableStriped';
import { useRack } from '../../../hooks/racks/useRack';
import { ModalRack } from '../../../components/racks/ModalRack';
import { TitleDataTable } from '../../../components/tableDataTable/TitleDataTable';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { AlertDataTable } from '../../../components/tableDataTable/AlertDataTable';


export const IndexRack = ({activeTab}) => {

    const {
        racks, method,
        name, code, slots, handleInputChange, validaciones,
        closeDialog, modal, modalTitle, loading,
        handleCreate, saveCreate,
        handleUpdate, saveUpdate,
        handleDelete, saveDelete,
        handleClearRack, searchRack,
        handleSearchRack, loadingExcel,
        handleExcelRack, showDeleteAlert, 
        closeDeleteAlert, modalAlert
    } = useRack({ activeTab });

    const headerStyle = {
            backgroundColor: "#1d5b83",
            color: "#fff",
            fontWeight: "bold",
            fontSize: "11px",
            borderRight: "1px solid #fff",
            borderBottom: "2px solid #fff",
    };

    const cellStyle = {
        fontSize: "11px",
        padding: "5px",
        textAlign: "center",
        fontFamily: "Montserrat, sans-serif",

    };

    const centerStyle = {
        ...cellStyle,
        textAlign: "center",
    };


    const actions = (rowData) => {

        return (
            <div className="d-flex justify-content-center align-items-center" style={{ gap: "3px", marginRight: "3px" }}>
                <Button
                    size="sm"
                    onClick={() => handleUpdate(rowData.id_rack)}
                    title="Editar"
                    className="btnTableAction"
                >
                    <i className="fa fa-edit iconTableAction"></i>
                </Button>


                <button
                    onClick={() => handleDelete(rowData.id_rack)}
                    title="Eliminar"
                    className="btnTableAction"
                    style={{
                        backgroundColor: "#bf0d0d"
                    }}
                >
                    <i className="fa fa-trash"></i>
                </button>
            </div>
        );
    };

    return (
        <Fragment>
            {/* <Breadcrumb parent="Configuraciones" title={"Gradillas"} /> */}
            <Container fluid={true}>
                <br />
                <Row>
                    <Col md="12">
                        <Card>
                            <CardBody className="p-1">
                                <TitleDataTable
                                    titleTable="Listado de gradillas"
                                    buttonActions={handleExcelRack}
                                    titleButton="Listado de gradillas"
                                    isDisbled={loadingExcel}
                                    loadingIsDisabled={loadingExcel}
                                    titleCreate="Crear gradillas"
                                    buttonActionsCreate={handleCreate}
                                    actionInput={handleSearchRack}
                                    valueFilter={searchRack}
                                    filterLocalStorage={true}
                                    cleanFilterLocalStorage={handleClearRack}
                                />
                                
                                <div className="table-responsive">
                                    <DataTable
                                        value={racks}
                                        paginator
                                        rows={10}
                                        responsiveLayout="scroll"
                                        rowsPerPageOptions={[10, 50, 100]} 
                                        className="data-table p-datatable-striped p-datatable-sm"
                                        emptyMessage={
                                            <div className="text-center">
                                                <img
                                                    src={require("../../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                                                    style={{ width: "32%" }}
                                                    alt="Sin resultados"
                                                />
                                                <br />
                                                <p className="badge badge-light-primary mt-2" style={{ fontSize: "15px" }}>
                                                    No se encontraron resultados.
                                                </p>
                                            </div>
                                        }
                                    >
                                        <Column header="#" body={(rowData, options) => { const globalIndex = options.rowIndex; return globalIndex + 1; }} headerStyle={headerStyle} style={centerStyle} />
                                        <Column 
                                            field="name"
                                            header="Nombre" 
                                            sortable
                                            body={(rowData) => (
                                                <span style={{ fontWeight: "bold" }}>
                                                    {rowData.name}
                                                </span>
                                            )}
                                            headerStyle={headerStyle} 
                                            style={cellStyle} 
                                        />
    
                                        <Column 
                                            field="code"
                                            sortable
                                            header="Código"
                                            body={(rowData) => (
                                                <span style={{ fontWeight: "bold" }}>
                                                    {rowData.code}
                                                </span>
                                            )}
                                            headerStyle={headerStyle}
                                            style={cellStyle} />
                                        
                                        <Column 
                                            field="slots" 
                                            sortable
                                            header="Espacios"
                                            body={(rowData) => { 
                                                return (
                                                    <span
                                                        style={{
                                                            width: "100px",          
                                                            textAlign: "center",
                                                            color: "#fff",
                                                            backgroundColor: "#1fbff0",
                                                            padding: "4px 0px",
                                                            borderRadius: "12px",
                                                            fontSize: "12px",
                                                            display: "inline-block",
                                                            fontWeight: "600",
                                                        }}
                                                    >
                                                        {rowData.slots}
                                                    </span>
                                                );
                                            }} 
                                            headerStyle={headerStyle} 
                                            style={cellStyle} 
                                        />
    
                                        <Column header="Acciones" body={actions} exportable={false} headerStyle={headerStyle} style={centerStyle} />
                                    </DataTable>
                                </div>
                                                        
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
            <ModalRack
                {
                ...{
                    modal, modalTitle, closeDialog, method, loading,
                    name, code, slots, handleInputChange, validaciones,
                    saveCreate, saveUpdate, saveDelete
                }
                }
            />

            {showDeleteAlert && (
                <AlertDataTable
                    titleAlert="Eliminar transporte"
                    visibleAlert={modalAlert}
                    onHideAlert={closeDeleteAlert}
                    sizeAlert="medium-dialog delete-method"
                    messageAlert="Esta acción no se puede deshacer. ¿Estás seguro de eliminar el transporte?"
                    alert1={true}
                    titleAlert1={name}
                    buttonAcept
                    titleNotLoading="Eliminar"
                    titleDanger="Cancelar"
                    actionAcept={saveDelete}
                />
            )}
        </Fragment>
    )
}
